<template>

        <b-dropdown-form class="dropdown-menu-right mt-3" style="width: 20rem;">
            <b-select :options="options" v-model="type" size="sm" class="mb-3">
                <template #first>
                    <b-form-select-option :value="null" disabled>Type</b-form-select-option>
                </template>
            </b-select>

            <b-input-group size="sm" class="mb-3">
                <b-form-textarea v-model="text"
                                 rows="3"
                                 max-rows="8"
                                 placeholder="Enter a note...">
                </b-form-textarea>
            </b-input-group>

            <div class="text-right">
                <b-button v-if='hasInitialValues' :disabled="!hasValues" @click="deleteNote()" size="sm" variant="warning" class="mr-2">Delete</b-button>
                <b-button :disabled="!hasValues" @click="doNote()" size="sm" variant="primary">{{hasInitialValues ? 'Update' : 'Add Note'}}</b-button>
            </div>
        </b-dropdown-form>

</template>

<script>
    import moment from "moment";

    export default {
        name: "Note",
        props: ['initialText', 'initialType', 'initialDate'],
        data() {
            return {
                text: this?.initialText || null,
                type: this?.initialType || null,
                options: [
                    { text: 'Order', value: 'general' },
                    { text: 'Shipping', value: 'shipping' },
                    { text: 'Customer', value: 'customer' },
                    { text: 'Phone', value: 'phone' },
                    { text: 'Email', value: 'email' },
                    { text: 'Instruction', value: 'instruction' },
                    { text: 'Cancellation Reason', value: 'cancellation'},
                    { text: 'Return', value: 'return'}
                ]
            }
        },
        methods: {
            doNote() {
                const noteObj = {
                    username: this.$auth.user.nickname,
                    date: this.initialDate || moment().format(),
                    type: this.type,
                    text: this.text,
                };
                this.$emit('addNote', noteObj);

                if (!this.initialType) this.type = null;
                if (!this.initialText) this.text = null;
            },
            deleteNote() {
                this.$emit('removeNote')
            }
        },
        computed: {
            hasValues() {
                return this.text && this.text.length && this.type && this.type.length;
            },
            hasInitialValues() {
                return this.initialText && this.initialText.length || this.initialType && this.initialType.length;
            }
        }
    }
</script>

<style scoped>

</style>